import api from './axios';

const BASE = '/members';

export const getMembers = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const createMember = (data) => api.post(BASE, data);

export const updateMember = (id, data) => api.put(`${BASE}/${id}`, data);

export const toggleMember = (id) => api.patch(`${BASE}/${id}/toggle-active`);

export const deleteMember = (id) => api.delete(`${BASE}/${id}`);
